import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import TinymceEditor from 'components/common/TinymceEditor';
import { getSize } from 'helpers/utils';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import ReactSelect from 'react-select';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { useNavigate } from 'react-router-dom';

const CreateProjectReport = () => {
  const [validated, setValidated] = useState(false);
  const [label, setLabel] = useState(null);
  const [reportDoc, setReportDoc] = useState(null);
  const [files, setFiles] = React.useState([]);

  const navigate = useNavigate();

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const labelOptions = [
    { value: '1', label: 'Urject 1' },
    { value: '2', label: 'Urject 2' },
    { value: '3', label: 'Urject 2' },
    { value: '4', label: 'Urject 3' }
  ];

  useEffect(() => {
    setFiles(acceptedFiles);
  }, [acceptedFiles]);

  const allFiles = files.map((file, index) => (
    <li
      className={classNames('list-group border p-2 px-3', {
        'mb-2': index !== files.length - 1
      })}
      key={file.path}
    >
      <Flex alignItems={'center'}>
        <FontAwesomeIcon
          className="me-3"
          icon={
            (file.type === 'image/png' && 'image') ||
            (file.type === 'image/jpeg' && 'image') ||
            (file.type === 'text/csv' && 'file') ||
            (file.type === 'application/pdf' && 'file-pdf') ||
            (file.type === 'application/zip' && 'file-archive') ||
            (file.type === 'video/mp4' && 'video') ||
            'paperclip'
          }
        />
        {file.path} - {getSize(file.size)}
        <Button
          variant="link"
          className="ms-auto p-0"
          onClick={() => handleRemove(file.path)}
        >
          <FontAwesomeIcon icon={'times'} />
        </Button>
      </Flex>
    </li>
  ));

  const handleRemove = path => {
    setFiles(files.filter(file => file.path !== path));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Card className="mb-3">
        <Card.Header>
          <Card.Title className="fw-medium mb-0 d-flex align-items-center">
            <FontAwesomeIcon icon={'ticket-alt'} className="me-2" />
            Submit Progress Report
          </Card.Title>
        </Card.Header>
        <Card.Body className="pt-0">
          <Row className="g-3">
            <Form.Group as={Col} md="6" controlId="Report Title">
              <Form.Label>
                Report Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control required type="text" placeholder="Report Title" />
              <Form.Control.Feedback type="invalid">
                Required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md={6}>
              <Form.Label>
                Cities <span className="text-danger">*</span>
              </Form.Label>
              <ReactSelect
                closeMenuOnSelect={true}
                options={labelOptions}
                placeholder="Select"
                classNamePrefix="react-select"
                className="we-raise"
                isMulti
                value={label}
                onChange={value => setLabel(value)}
              />
              <Form.Control.Feedback type="invalid">
                Required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="12" controlId="Case Study">
              <Form.Label>
                Report Description <span className="text-danger">*</span>
              </Form.Label>
              <TinymceEditor
                value={reportDoc}
                handleChange={newValue => setReportDoc(newValue)}
                height={'300'}
              />
            </Form.Group>
            <Form.Group as={Col} md="12" controlId="Video URL">
              <Form.Label>
                Video URL <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control required type="text" placeholder="Video URL" />
              <Form.Control.Feedback type="invalid">
                Required
              </Form.Control.Feedback>
            </Form.Group>
            <hr />
            <Col md={12} className="mt-0">
              <div className="mt-2">
                <div
                  {...getRootProps({ className: 'dropzone-area h-auto py-4' })}
                >
                  <input {...getInputProps({ multiple: true })} />
                  <Flex justifyContent="center" alignItems={'center'}>
                    <img src={cloudUpload} alt="" width={30} className="me-2" />
                    <p className="fs-0 mb-0 text-700">Drop your file here</p>
                  </Flex>
                </div>
                <div className="mt-3">
                  {files.length > 0 && (
                    <div
                      style={{ backgroundColor: '#F9FAFD' }}
                      className="rounded-2"
                    >
                      <ul className="p-4">{allFiles}</ul>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <Flex
            justifyContent="between"
            className="flex-column flex-md-row align-items-center"
          >
            <p className="mb-3 mb-md-0 fs-2 fw-medium">Progress Report</p>
            <Button className="w-215px" onClick={() => navigate(-1)}>
              Submit
            </Button>
          </Flex>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default CreateProjectReport;
